import {
  CLEAR_ALL_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_SUCCESS,
  LOGOUT_SUCCESS,
  UPDATE_NOTIFCATION_STATUS_SUCCESS,
} from "../Types";

const initalState = {
  userNotifications: [],
};

export default function notificationReducer(state = initalState, action) {
  switch (action.type) {
    case GET_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        userNotifications: action.body.data,
      };
    }
    case UPDATE_NOTIFCATION_STATUS_SUCCESS: {
      const { data = [] } = action.body;
      return {
        ...state,
        userNotifications: state.userNotifications.map((ele) => {
          if (ele.id === data[0].id) {
            return {
              ...ele,
              isRead: true,
            };
          }
          return ele;
        }),
      };
    }
    case CLEAR_ALL_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        userNotifications: [],
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initalState };
    }
    default:
      return state;
  }
}
